export const servicesData = [
  {
    id: 'corporate-contracts',
    title: 'Corporate & Business Contracts',
    category: 'Business Law',
    icon: 'FileText',
    shortDesc: 'Comprehensive contract drafting, review, and negotiation services.',
    path: '/services/corporate-contracts',
  },
  {
    id: 'business-formation',
    title: 'Corporate & Business Formation',
    category: 'Business Law',
    icon: 'Building2',
    shortDesc: 'Entity formation, structuring, and corporate governance guidance.',
    path: '/services/business-formation',
  },
  {
    id: 'business-transaction',
    title: 'Business Transaction',
    category: 'Business Law',
    icon: 'Handshake',
    shortDesc: 'Strategic guidance for business transactions and commercial deals.',
    path: '/services/business-transaction',
  },
  {
    id: 'mergers-acquisitions',
    title: 'Mergers & Acquisitions',
    category: 'Business Law',
    icon: 'ArrowLeftRight',
    shortDesc: 'Expert M&A advisory, due diligence, and transaction execution.',
    path: '/services/mergers-acquisitions',
  },
  {
    id: 'non-profit-law',
    title: 'Non-Profit Law',
    category: 'Business Law',
    icon: 'Heart',
    shortDesc: 'Formation, compliance, and governance for non-profit organizations.',
    path: '/services/non-profit-law',
  },
  {
    id: 'government-contracting',
    title: 'Government Contracting',
    category: 'Compliance & Protection',
    icon: 'Landmark',
    shortDesc: 'Navigate federal contracting requirements and compliance.',
    path: '/services/government-contracting',
  },
  {
    id: 'business-disputes',
    title: 'Business Disputes',
    category: 'Compliance & Protection',
    icon: 'Scale',
    shortDesc: 'Litigation and dispute resolution for commercial matters.',
    path: '/services/business-disputes',
  },
  {
    id: 'anti-corruption',
    title: 'Anti-Corruption Compliance',
    category: 'Compliance & Protection',
    icon: 'ShieldCheck',
    shortDesc: 'FCPA compliance, risk assessment, and internal investigations.',
    path: '/services/anti-corruption',
  },
  {
    id: 'immigration',
    title: 'Immigration',
    category: 'Compliance & Protection',
    icon: 'Users',
    shortDesc: 'Business immigration, work visas, and employment authorization.',
    path: '/services/immigration',
  },
  {
    id: 'trademark',
    title: 'Trademark Registration',
    category: 'Intellectual Property',
    icon: 'Copyright',
    shortDesc: 'Trademark search, registration, and enforcement services.',
    path: '/services/trademark',
  },
  {
    id: 'copyright',
    title: 'Copyright Registration',
    category: 'Intellectual Property',
    icon: 'FileCheck',
    shortDesc: 'Copyright registration and protection for creative works.',
    path: '/services/copyright',
  },
];

export const serviceCategories = [
  'Business Law',
  'Compliance & Protection',
  'Intellectual Property',
];
